import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_2 = { class: "fw-bold mb-1" };
const _hoisted_3 = { class: "text-secondary m-0" };
const _hoisted_4 = {
    key: 0,
    class: "text-secondary mt-2 mb-0"
};
const _hoisted_5 = {
    key: 0,
    class: "alert alert-danger mb-3",
    role: "alert"
};
const _hoisted_6 = { class: "tab-content rounded bg-white p-3 mb-4" };
const _hoisted_7 = {
    class: "tab-pane fade show active",
    id: "details-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "details-tab",
    tabindex: "0"
};
const _hoisted_8 = { class: "row mb-4" };
const _hoisted_9 = { class: "col-lg-6 col-12" };
const _hoisted_10 = { class: "form-check mb-3" };
const _hoisted_11 = { class: "form-check mb-3" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = { class: "input-group mb-3" };
const _hoisted_16 = { class: "form-floating" };
const _hoisted_17 = { class: "input-group" };
const _hoisted_18 = { class: "form-floating" };
const _hoisted_19 = { class: "input-group" };
const _hoisted_20 = { class: "form-floating" };
const _hoisted_21 = { class: "input-group" };
const _hoisted_22 = { class: "form-floating" };
const _hoisted_23 = { class: "input-group" };
const _hoisted_24 = { class: "form-floating" };
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = ["value"];
const _hoisted_27 = { class: "form-floating mb-3" };
const _hoisted_28 = ["value"];
const _hoisted_29 = { class: "form-floating mb-3" };
const _hoisted_30 = { class: "mb-3" };
const _hoisted_31 = { class: "mb-3" };
const _hoisted_32 = { class: "col-12 col-lg-6" };
const _hoisted_33 = { class: "mb-4" };
const _hoisted_34 = { class: "mb-3" };
const _hoisted_35 = { class: "mb-4" };
const _hoisted_36 = { class: "mb-3" };
const _hoisted_37 = { class: "row mt-4" };
const _hoisted_38 = { class: "col-12 col-lg-6" };
const _hoisted_39 = {
    class: "tab-pane fade",
    id: "print-areas-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "print-areas-tab",
    tabindex: "0"
};
const _hoisted_40 = {
    class: "tab-pane fade",
    id: "product-images-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "product-images-tab",
    tabindex: "0"
};
const _hoisted_41 = {
    class: "tab-pane fade",
    id: "variants-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "variants-tab",
    tabindex: "0"
};
import { FilterMatchMode } from '@primevue/core/api';
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { MultiSelect, useConfirm } from 'primevue';
import TinyEditor from '@/Components/TinyEditor.vue';
import axios from 'axios';
import ProductImages from '@/Tenant/Components/ProductImages.vue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
import PrintArea from './PrintArea.vue';
import Variants from './Variants.vue';
import ProductPriceAddition from '@/Tenant/Components/ProductPriceAddition.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        lid: {
            type: Object,
            required: true
        },
        materials: Object,
        productTypes: Object,
        printModes: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const printAreaKey = ref(0);
        const variantsKey = ref(0);
        const editLidForm = useForm({
            artNo: props.lid?.artNo ?? '',
            name: props.lid?.name ?? '',
            nameEn: props.lid?.nameEn ?? '',
            description: props.lid?.description ?? '',
            descriptionEn: props.lid?.descriptionEn ?? '',
            weight: props.lid?.weight ?? 0,
            height: props.lid?.height ?? 0,
            diameter: props.lid?.diameter ?? 0,
            width: props.lid?.width ?? 0,
            depth: props.lid?.depth ?? 0,
            materialUuid: props.lid?.materialUuid ?? '',
            productTypeUuid: props.lid?.productTypeUuid ?? '',
            deliveryDays: props.lid?.deliveryDays ?? null,
            active: props.lid?.active ?? false,
            printNotPossible: props.lid?.printNotPossible ?? false
        });
        const productCategories = ref([]);
        const selectedProductCategories = ref([]);
        const availableMouthOptions = ref([]);
        const selectedMouthOptions = ref([]);
        onMounted(() => {
            // const modalElement = document.getElementById('createAddress');
            // if (modalElement) {
            //     createAddressModal.value = new Modal(modalElement);
            // }
            loadAvailableMouthOptions();
            selectedMouthOptions.value = props.lid?.mouthOptions.map((mouthOption) => {
                return mouthOption.uuid;
            }) ?? [];
            loadAvailableProductCategories();
            selectedProductCategories.value = props.lid?.productCategories.map((category) => {
                return category.uuid;
            }) ?? [];
        });
        function loadAvailableMouthOptions() {
            axios.post(route('admin.mouthOptions.load')).then((response) => {
                availableMouthOptions.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadAvailableProductCategories() {
            axios.post(route('admin.productCategories.load')).then((response) => {
                productCategories.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updateLid() {
            if (props.lid == null) {
                return;
            }
            editLidForm.transform((data) => ({
                art_no: data.artNo,
                name: data.name,
                name_en: data.nameEn,
                description: data.description,
                description_en: data.descriptionEn,
                weight: data.weight,
                height: data.height,
                diameter: data.diameter,
                width: data.width,
                depth: data.depth,
                material_uuid: data.materialUuid,
                product_type_uuid: data.productTypeUuid,
                delivery_days: data.deliveryDays,
                active: data.active,
                print_not_possible: data.printNotPossible
            }))
                .submit('put', route('admin.lids.update', props.lid.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeLid() {
            confirm.require({
                message: 'Soll der Verschluss wirklich gelöscht werden?',
                header: 'Verschluss löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.lid == null) {
                        return;
                    }
                    router.delete(route('admin.lids.destroy', props.lid.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function updateProductCategories() {
            if (props.lid == null) {
                return;
            }
            if (selectedProductCategories.value.length === 0) {
                showErrorMessage('Bitte wählen Sie mindestens eine Produktkategorie aus.');
                return;
            }
            router.post(route('admin.lids.productCategories.update', props.lid.uuid), {
                'productCategoryUuids': selectedProductCategories.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateMouthOptions() {
            router.post(route('admin.lids.mouthOptions.update', props.lid.uuid), {
                'mouthOptionUuids': selectedMouthOptions.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function copyLid() {
            confirm.require({
                message: 'Soll der Verschluss wirklich kopiert werden?',
                header: 'Verschluss kopieren?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Ja, Verschluss kopieren',
                accept: () => {
                    if (props.lid == null) {
                        return;
                    }
                    router.post(route('admin.lids.copy.store', props.lid.uuid), {}, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Verschluss" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", _hoisted_2, "Verschluss: " + _toDisplayString(props.lid.name), 1),
                                _createElementVNode("p", _hoisted_3, "Letzte Änderung: " + _toDisplayString(_unref(formatDate)(props.lid.updatedAt, true)), 1),
                                (props.lid.supplier)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Lieferant: " + _toDisplayString(props.lid.supplier.name), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                    class: "btn btn-primary text-white d-inline-flex align-items-center",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (copyLid()))
                                }, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-copy",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                                            })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Verschluss kopieren", -1)
                                    ]))])
                            ])
                        ]),
                        (props.lid.priceBundle && !props.lid.priceBundle.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Produkt ist mit einem inaktiven Preis-Bundle verknüpft. Produkt kann somit nicht eingesetzt werden."))
                            : _createCommentVNode("", true),
                        _cache[53] || (_cache[53] = _createElementVNode("ul", {
                            class: "nav nav-underline mb-3",
                            role: "tablist"
                        }, [
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "details-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#details-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "details-tab-pane",
                                    "aria-selected": "true"
                                }, "Details")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "print-areas-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#print-areas-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "print-areas-tab-pane",
                                    "aria-selected": "false"
                                }, "Druckbereich")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "product-images-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#product-images-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "product-images-tab-pane",
                                    "aria-selected": "false"
                                }, "Produkt-Bilder")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "variants-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#variants-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "variants-tab-pane",
                                    "aria-selected": "false"
                                }, "Varianten")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(updateLid, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "active",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editLidForm).active) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editLidForm).active]
                                                ]),
                                                _cache[21] || (_cache[21] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "active"
                                                }, "Aktiv (Verschluss kann konfiguriert werden)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "printNotPossible",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editLidForm).printNotPossible) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editLidForm).printNotPossible]
                                                ]),
                                                _cache[22] || (_cache[22] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "printNotPossible"
                                                }, "Verschluss kann nicht bedruckt werden", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "artNo",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editLidForm).artNo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editLidForm).artNo]
                                                ]),
                                                _cache[23] || (_cache[23] = _createElementVNode("label", { for: "artNo" }, "Artnr.", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "name",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editLidForm).name) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editLidForm).name]
                                                ]),
                                                _cache[24] || (_cache[24] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "nameEn",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editLidForm).nameEn) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editLidForm).nameEn]
                                                ]),
                                                _cache[25] || (_cache[25] = _createElementVNode("label", { for: "nameEn" }, "Name (en)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editLidForm).weight) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editLidForm).weight]
                                                    ]),
                                                    _cache[26] || (_cache[26] = _createElementVNode("label", { for: "weight" }, "Gewicht", -1))
                                                ]),
                                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "input-group-text" }, "g", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editLidForm).height) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editLidForm).height]
                                                    ]),
                                                    _cache[28] || (_cache[28] = _createElementVNode("label", { for: "weight" }, "Höhe", -1))
                                                ]),
                                                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[41] || (_cache[41] = _createElementVNode("p", { class: "form-text mb-3" }, "Exakte Höhe von oben bis unten ohne Toleranz.", -1)),
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("div", _hoisted_20, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editLidForm).diameter) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editLidForm).diameter]
                                                    ]),
                                                    _cache[30] || (_cache[30] = _createElementVNode("label", { for: "diameter" }, "Durchmesser", -1))
                                                ]),
                                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[42] || (_cache[42] = _createElementVNode("p", { class: "form-text mb-3" }, "Durchmesser des kompletten Verschlusses ohne Toleranz.", -1)),
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editLidForm).width) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editLidForm).width]
                                                    ]),
                                                    _cache[32] || (_cache[32] = _createElementVNode("label", { for: "diameter" }, "Breite", -1))
                                                ]),
                                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[43] || (_cache[43] = _createElementVNode("p", { class: "form-text mb-3" }, "Breite des Verschlusses. Entspricht bei runden Verschlüssen dem Durchmesser.", -1)),
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(editLidForm).depth) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editLidForm).depth]
                                                    ]),
                                                    _cache[34] || (_cache[34] = _createElementVNode("label", { for: "diameter" }, "Tiefe", -1))
                                                ]),
                                                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[44] || (_cache[44] = _createElementVNode("p", { class: "form-text mb-3" }, "Tiefe des Verschlusses. Entspricht bei runden Verschlüssen dem Durchmesser.", -1)),
                                            _createElementVNode("div", _hoisted_25, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "material",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(editLidForm).materialUuid) = $event))
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.materials, (material) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: material.uuid
                                                        }, _toDisplayString(material.name), 9, _hoisted_26));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editLidForm).materialUuid]
                                                ]),
                                                _cache[36] || (_cache[36] = _createElementVNode("label", { for: "material" }, "Material", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "productType",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(editLidForm).productTypeUuid) = $event))
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productTypes, (productType) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: productType.uuid
                                                        }, _toDisplayString(productType.name), 9, _hoisted_28));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editLidForm).productTypeUuid]
                                                ]),
                                                _cache[37] || (_cache[37] = _createElementVNode("label", { for: "productType" }, "Produkttyp", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_29, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "deliveryDays",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(editLidForm).deliveryDays) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editLidForm).deliveryDays]
                                                ]),
                                                _cache[38] || (_cache[38] = _createElementVNode("label", { for: "deliveryDays" }, "Lieferzeit in Tagen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_30, [
                                                _cache[39] || (_cache[39] = _createElementVNode("label", {
                                                    for: "description",
                                                    class: "mb-2"
                                                }, "Beschreibung", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "description",
                                                    modelValue: _unref(editLidForm).description,
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(editLidForm).description) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_31, [
                                                _cache[40] || (_cache[40] = _createElementVNode("label", {
                                                    for: "descriptionEn",
                                                    class: "mb-2"
                                                }, "Beschreibung (en)", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "descriptionEn",
                                                    modelValue: _unref(editLidForm).descriptionEn,
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(editLidForm).descriptionEn) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _cache[45] || (_cache[45] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 32),
                                        (props.lid.canRemove)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                                onClick: removeLid
                                            }, [...(_cache[46] || (_cache[46] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-x-circle",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                        _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Verschluss löschen", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                            _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Produktkategorien", -1)),
                                            _createElementVNode("div", _hoisted_34, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedProductCategories.value,
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((selectedProductCategories).value = $event)),
                                                    options: productCategories.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Produktkategorien wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateProductCategories
                                            }, [...(_cache[47] || (_cache[47] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                            _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Verschluss-Mündungen", -1)),
                                            _createElementVNode("div", _hoisted_36, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedMouthOptions.value,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((selectedMouthOptions).value = $event)),
                                                    options: availableMouthOptions.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Verschluss-Mündungen wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateMouthOptions
                                            }, [...(_cache[49] || (_cache[49] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[52] || (_cache[52] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                                    _createVNode(ProductPriceOption, {
                                        lid: props.lid,
                                        priceBundleUuid: props.lid.priceBundleUuid
                                    }, null, 8, ["lid", "priceBundleUuid"]),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _cache[51] || (_cache[51] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preis-Aufschlag", -1)),
                                            _createVNode(ProductPriceAddition, {
                                                lid: props.lid
                                            }, null, 8, ["lid"])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                (_openBlock(), _createBlock(PrintArea, {
                                    lid: props.lid,
                                    printModes: props.printModes,
                                    key: printAreaKey.value,
                                    onUpdate: _cache[18] || (_cache[18] = ($event) => (printAreaKey.value++))
                                }, null, 8, ["lid", "printModes"]))
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                                _createVNode(ProductImages, {
                                    lid: props.lid
                                }, null, 8, ["lid"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                                (_openBlock(), _createBlock(Variants, {
                                    lid: props.lid,
                                    key: variantsKey.value,
                                    onUpdate: _cache[19] || (_cache[19] = ($event) => (variantsKey.value++))
                                }, null, 8, ["lid"]))
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
